/**
 * Questo file contiene il tipo 'formStep'
 * riporta l'enim dei vari step del forum per renderlo piu leggibile
 */

export enum formStep {
	Home = 0,
	Area = 1,
	Prestazione = 2,
	Professionista = 3,
	DataPreventivo = 4,	
	Authentication = 5,
	SelectAssistito = 6,
	SelectModalitaPagamento = 7,
	ResultPrenotazione = 8,
	Pagamento = 9,
}

export enum personalAreaStep {
	datiUtente = "1",
	familiari = "2",
	prenotazioni = "3",
	sospesi = "4",
	fatture = "5",
	privacy = "6",
	help = "7",
}
